import { FormattedMessage } from "react-intl";
import { PrintStatus } from "common/api/decimal/methods/course";
import clsx from "clsx";
import { ReactNode } from "react";
import OffScreen from "common/core-ui/OffScreen";
import { isPickupDateInFuture } from "./printStatusHelper";

const PrintStatusTagWrapper = ({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) => (
  <div>
    <div data-testid="print-status-tag" className={clsx("vst-tag", className)}>
      {children}
    </div>
  </div>
);

const MoreInfo = () => (
  <OffScreen>
    <FormattedMessage
      defaultMessage={"See 'View Details' for more information"}
    />
  </OffScreen>
);

export default function PrintStatusTag({
  printStatus,
  pickupDate,
}: {
  printStatus?: PrintStatus;
  pickupDate?: string | null;
}) {
  const preparingTag = (
    <PrintStatusTagWrapper className="vst-tag-variant-frost">
      <FormattedMessage defaultMessage={"Preparing for Campus Pickup"} />
      <MoreInfo />
    </PrintStatusTagWrapper>
  );

  if (printStatus === "Not Ready To Issue") {
    return preparingTag;
  } else if (printStatus === "Ready To Issue") {
    return (
      <PrintStatusTagWrapper className="vst-tag-variant-green">
        <FormattedMessage defaultMessage={"Ready for Campus Pickup"} />
        <MoreInfo />
      </PrintStatusTagWrapper>
    );
  } else if (printStatus === "Not Issued") {
    if (isPickupDateInFuture(pickupDate)) {
      return preparingTag;
    } else {
      return (
        <PrintStatusTagWrapper className="vst-tag-variant-green">
          <FormattedMessage defaultMessage={"Ready for Campus Pickup"} />
          <MoreInfo />
        </PrintStatusTagWrapper>
      );
    }
  } else if (printStatus === "Issued") {
    return (
      <PrintStatusTagWrapper className="vst-tag-variant-green">
        <FormattedMessage defaultMessage={"Picked Up"} />
        <MoreInfo />
      </PrintStatusTagWrapper>
    );
  } else if (printStatus === "Not Returned") {
    return (
      <PrintStatusTagWrapper className="vst-tag-variant-red">
        <FormattedMessage defaultMessage={"Needs to be Returned"} />
        <MoreInfo />
      </PrintStatusTagWrapper>
    );
  } else {
    return null;
  }
}
